import React, { useEffect, useState } from 'react';
import ActionButtons from '../../../components/actionbutton';
import Filter from '../../../assets/images/Filter.svg';
import useDebounce from '../../../components/Debounce';
import { ReactComponent as SearchIcon } from '../../../assets/images/Search.svg';
import PaginationComponent from '../../../components/Pagination';
import userProfile from '../../../assets/images/userProfile.svg';
import FilterDrawer from './filterDrawer';
import { useHook as CustomerHook } from './useHook';
import { useSelector } from 'react-redux';
import {
  Button,
  Drawer,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  setCustomerDetailsAction,
  setCustomerUnitDetailsAction,
} from '../../../stores/actionTypes/customerManagementAction';
import { Unauthorized } from '../../../components/index';
import { closeBlackIcon } from '../../../assets/images';
import { Status } from '../../../components';
import { ErrorMessage } from '../../../permissionErrorMessage/PermissionMessage';
import { useHook as EquipmentsDashboard } from '../hardware/equipments/useHook';
interface Props {
  pagePermissionIDs: unknown;
}
const CustomerManagement: React.FC<Props> = ({ pagePermissionIDs }) => {
  const userRole = localStorage.getItem('role');
  const { allCategory } = useSelector((state: any) => state.equipments);
  const canlistPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('customers::list');

  const canCategorylistPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('categories::list');

  const requiredAccess = (
    <section className="required_access_section">
      <p>you require below access:</p>
      <ul>
        <li>{ErrorMessage['customers::list'] || ''}</li>
        <li>{ErrorMessage['categories::list'] || ''}</li>
      </ul>
    </section>
  );

  const navigate = useNavigate();
  const {
    fetchCustomerList,
    fetchDealerCustomerList,
    fetchGetDealerCustomerFilter,
  } = CustomerHook();
  const dispatch = useDispatch();
  const { customerManagementList, customerFilter } = useSelector(
    (state: any) => state.customerManagement,
  );
  const { fetchGetListCategory, fetchDealerGetListCategory } =
    EquipmentsDashboard();
  const [filterDrawerOpen, setFliterDrawerOpen] = useState(false);
  const [search, setSearch] = useState<string>('');
  const debouncedSearch = useDebounce(search, 1000);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filterData, setFilterData] = useState<string[]>([]);
  const [equipmentFilter, setEquipmentFilter] = useState<string[]>([]);
  const [serialNumber, setSerialNumber] = useState<string[]>([]);
  const [categoryFilter, setCategoryFilter] = useState<string[]>([]);
  const [subcategoryFilter, setSubCategoryFilter] = useState<string[]>([]);
  const [seeMoreIndex, setSeeMoreIndex] = useState<number>(2);
  const [filterDrawerData, setFilterDrawerData] = useState<any>(null);

  useEffect(() => {
    if (
      !(allCategory?.length > 0) &&
      canCategorylistPermission &&
      userRole !== 'dealer'
    ) {
      fetchGetListCategory({});
    }
    if (!customerFilter) {
      fetchGetDealerCustomerFilter();
    }
  }, []);

  useEffect(() => {
    getCustomerList(1, rowsPerPage, search);
    setSeeMoreIndex(filterData?.length);
    setFilterDrawerData({
      equipment: equipmentFilter.length > 0 ? equipmentFilter : [],
      serialNumber: serialNumber.length > 0 ? serialNumber : [],
      category: categoryFilter.length > 0 ? categoryFilter : [],
      subCategory: subcategoryFilter.length > 0 ? subcategoryFilter : [],
    });
  }, [filterData]);

  //handle remove filter
  const handleRemoveFilter = (filterName: string) => {
    if (equipmentFilter.includes(filterName)) {
      const removeData = equipmentFilter?.filter((data) => data !== filterName);
      setEquipmentFilter(removeData);

      //rmove filterData
      const removeFilterData = filterData?.filter(
        (data) => data !== filterName,
      );
      setFilterData(removeFilterData);
    } else if (serialNumber.includes(filterName)) {
      const removeData = serialNumber?.filter((data) => data !== filterName);
      setSerialNumber(removeData);

      //rmove filterData
      const removeFilterData = filterData?.filter(
        (data) => data !== filterName,
      );
      setFilterData(removeFilterData);
    } else if (subcategoryFilter.includes(filterName)) {
      const removeData = subcategoryFilter?.filter(
        (data) => data !== filterName,
      );
      setSubCategoryFilter(removeData);

      //rmove filterData
      const removeFilterData = filterData?.filter(
        (data) => data !== filterName,
      );
      setFilterData(removeFilterData);
    } else if (categoryFilter.includes(filterName)) {
      const removeData = categoryFilter.filter((data) => data !== filterName);
      setCategoryFilter(removeData);

      if (userRole === 'dealer') {
        // Find the subcategories to remove based on the category name
        const removedSubcategories =
          customerFilter?.category?.find(
            (category: { categoryName: string }) =>
              category.categoryName === filterName,
          )?.subCategories || [];

        // Remove subcategories from subcategoryFilter
        const removeSubCategoryData = subcategoryFilter.filter(
          (item) => !removedSubcategories.includes(item),
        );
        setSubCategoryFilter(removeSubCategoryData);

        // Remove from filterData (both category and subcategory)
        const removeFilterData = filterData.filter(
          (item) => !removedSubcategories.includes(item) && item !== filterName,
        );
        setFilterData(removeFilterData);
      } else {
        // Find the subcategories to remove based on the category name
        const removedSubcategories =
          allCategory?.find(
            (category: { categoryName: string }) =>
              category.categoryName === filterName,
          )?.subCategories || [];

        // Remove subcategories from subcategoryFilter
        const removeSubCategoryData = subcategoryFilter.filter(
          (item) => !removedSubcategories.includes(item),
        );
        setSubCategoryFilter(removeSubCategoryData);

        // Remove from filterData (both category and subcategory)
        const removeFilterData = filterData.filter(
          (item) => !removedSubcategories.includes(item) && item !== filterName,
        );
        setFilterData(removeFilterData);
      }
    }

    setCurrentPage(1);
  };

  //getCustomerList
  const getCustomerList = async (
    pagenumber?: number,
    row_perpage?: number,
    search: unknown = '',
    filters?: any,
    sort: { orderBy: string; order: number } = {
      orderBy: 'updatedAt',
      order: -1,
    },
  ) => {
    const payload = {
      sort: sort,
      search: search,
      filters: {
        equipment: equipmentFilter.length > 0 ? equipmentFilter : null,
        serialNumber: serialNumber.length > 0 ? serialNumber : null,
        category: categoryFilter.length > 0 ? categoryFilter : null,
        subCategory: subcategoryFilter.length > 0 ? subcategoryFilter : null,
      },
      limit: row_perpage ? row_perpage : rowsPerPage,
      offset: pagenumber
        ? (pagenumber - 1) * rowsPerPage
        : (currentPage - 1) * rowsPerPage,
    };
    if (userRole === 'dealer') {
      await fetchDealerCustomerList(payload).then((res: any) => {
        const totalPage = res?.count
          ? Math.ceil(res?.count / (row_perpage ? row_perpage : rowsPerPage))
          : 1;
        setTotalPages(totalPage);
      });
    } else if (canlistPermission && canCategorylistPermission) {
      await fetchCustomerList(payload).then((res: any) => {
        const totalPage = res?.count
          ? Math.ceil(res?.count / (row_perpage ? row_perpage : rowsPerPage))
          : 1;
        setTotalPages(totalPage);
      });
    }
  };

  //search
  const handleSearchChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const search = event.target.value;
    // Allow only letters, numbers, and spaces
    const regex = /^[a-zA-Z0-9 ]*$/;
    if (regex.test(search)) {
      setSearch(search);
      if (!search) {
        getCustomerList(currentPage, rowsPerPage, search);
      } else {
        setCurrentPage(1);
      }
    }
  };

  useEffect(() => {
    if (debouncedSearch) {
      getCustomerList(1, rowsPerPage, search);
      setCurrentPage(1);
    }
  }, [debouncedSearch]);

  //filter
  const fliterOpenDrawer = () => {
    setFliterDrawerOpen(true);
  };

  const fliterCloseDrawer = () => {
    setFliterDrawerOpen(false);
  };
  const filterSubmit = (data: any) => {
    if (data !== undefined && data !== null) {
      const filterData = [
        ...data.equipment,
        ...data.serialNumber,
        ...data.category,
        ...data.subCategory,
      ];
      setFilterData(filterData);
      setEquipmentFilter(data.equipment);
      setSerialNumber(data.serialNumber);
      setCategoryFilter(data.category);
      setSubCategoryFilter(data.subCategory);
    }
    setFliterDrawerOpen(false);
  };

  useEffect(() => {
    getCustomerList();
    dispatch(setCustomerDetailsAction({}));
    dispatch(setCustomerUnitDetailsAction({}));
  }, [canlistPermission, canCategorylistPermission]);

  //pagination
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    getCustomerList(page, rowsPerPage, search);
  };
  const handleRowsPerPageChange = (value: number) => {
    getCustomerList(1, value, search);
    setRowsPerPage(value);
    setCurrentPage(1);
  };

  //dateformat
  function formatDate(isoDate: string | Date) {
    const months = [
      'JAN',
      'FEB',
      'MAR',
      'APR',
      'MAY',
      'JUN',
      'JUL',
      'AUG',
      'SEP',
      'OCT',
      'NOV',
      'DEC',
    ];

    const date = new Date(isoDate);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  }

  function formatTime(isoDate: string | Date): string {
    const date = new Date(isoDate);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  }

  return (
    <>
      {!canlistPermission || !canCategorylistPermission ? (
        <Unauthorized requiredAccess={requiredAccess} />
      ) : (
        <>
          <section className="customer_management-header">
            <ActionButtons
              image={Filter}
              title={'Filter'}
              action={fliterOpenDrawer}
              activeData={filterData}
            />
            <div className="table-header-btn">
              <TextField
                variant="outlined"
                placeholder="Search"
                value={search}
                onChange={handleSearchChange}
                InputProps={{
                  startAdornment: <SearchIcon />,
                }}
                className="search-input"
              />
            </div>
          </section>
          <section className="manufacture_filterlist-data">
            {filterData?.slice(0, seeMoreIndex).map((data, index) => (
              <div key={index} className="filterlist">
                <p>{data}</p>
                <Button onClick={() => handleRemoveFilter(data)}>
                  <img src={closeBlackIcon} alt="Delete Icon" width={13} />
                </Button>
              </div>
            ))}
            {filterData?.length > 2 && seeMoreIndex === 2 && (
              <div className="see_more_data">
                <Button
                  onClick={() => setSeeMoreIndex(filterData?.length)}
                >{`+${filterData?.length - 2} More`}</Button>
              </div>
            )}
            {filterData?.length > 2 && seeMoreIndex !== 2 && (
              <div className="see_more_data">
                <Button onClick={() => setSeeMoreIndex(2)}>show less</Button>
              </div>
            )}
          </section>
          <TableContainer
            className="dashboard_table-container "
            component={Paper}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Customer</TableCell>
                  <TableCell>
                    {userRole === 'dealer' ? 'Subscription status' : 'Email'}
                  </TableCell>
                  <TableCell>Registered on</TableCell>
                  {/* <TableCell> </TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {customerManagementList?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={2}>
                      <Typography variant="body1" align="left">
                        No Data found
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  customerManagementList?.map((data: any, index: any) => (
                    <TableRow key={index}>
                      <TableCell>
                        <div className="customer_management_name-data">
                          <img
                            src={data?.image ? data?.image : userProfile}
                            width={40}
                            alt="User Profile"
                               onError={e => {
                                // Prevent infinite loop if fallback also fails
                                e.currentTarget.onerror = null;
                                // Set fallback SVG or image from assets or public folder
                                e.currentTarget.src = userProfile;
                              }}
                          />{' '}

                      
                               <a target="_blank" rel="noopener noreferrer" href={`/customermanagement/edit/${data?.firstName + ' ' + data?.lastName}/${data?.customerID}`}>
    {data?.firstName} {data?.lastName}
  </a>
                       
                        </div>
                      </TableCell>
                      <TableCell>
                        {userRole === 'dealer' ? (
                          <Status
                            status={data?.subscriptionStatus || 'Deactivate'}
                          />
                        ) : (
                          <p>{data?.email || '-'}</p>
                        )}
                      </TableCell>
                      <TableCell>
                        <p>
                          {formatDate(data?.createdAt) +
                            '  ' +
                            formatTime(data?.createdAt)}
                        </p>
                      </TableCell>
                     
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <PaginationComponent
            rowsPerPageOptions={[5, 10, 20, 30]}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            totalPages={totalPages}
          />

          <Drawer
            open={filterDrawerOpen}
            anchor="right"
            onClose={fliterCloseDrawer}
          >
            <FilterDrawer
              fliterCloseDrawer={fliterCloseDrawer}
              filterSubmit={filterSubmit}
              filterDrawerData={filterDrawerData}
            />
          </Drawer>
        </>
      )}
    </>
  );
};

export default CustomerManagement;
